import { z } from "zod";
import { e164PhoneSchema, isoDateSchema, objectIdSchema, paginationQuerySchema } from "./common";
export const consentSourceEnum = z.enum(["IMPORT", "API", "WEB_FORM", "MANUAL"]);
export const contactSchema = z.object({
    _id: objectIdSchema,
    userId: objectIdSchema,
    phone: e164PhoneSchema,
    name: z.string().max(120).nullable(),
    attributes: z.record(z.string(), z.string()).default({}),
    tags: z.array(z.string().max(40)).default([]),
    isOptedOut: z.boolean(),
    optedOutAt: isoDateSchema.nullable(),
    consentSource: consentSourceEnum,
    createdAt: isoDateSchema,
});
export const createContactSchema = z.object({
    phone: e164PhoneSchema,
    name: z.string().max(120).optional(),
    attributes: z.record(z.string(), z.string()).optional(),
    tags: z.array(z.string().max(40)).optional(),
    consentSource: consentSourceEnum.default("MANUAL"),
});
export const updateContactSchema = createContactSchema.partial();
export const listContactsQuerySchema = paginationQuerySchema.extend({
    search: z.string().max(120).optional(),
    tag: z.string().max(40).optional(),
    isOptedOut: z.coerce.boolean().optional(),
});
export const importContactsSchema = z.object({
    csvBase64: z.string().min(1),
    dryRun: z.boolean().default(true),
    defaultConsentSource: consentSourceEnum.default("IMPORT"),
});
export const importPreviewSchema = z.object({
    totalRows: z.number().int().min(0),
    validRows: z.number().int().min(0),
    invalidRows: z.number().int().min(0),
    duplicateRows: z.number().int().min(0),
    errors: z.array(z.object({ row: z.number().int(), reason: z.string() })).max(200),
});
export const contactGroupSchema = z.object({
    _id: objectIdSchema,
    userId: objectIdSchema,
    name: z.string().min(1).max(120),
    createdAt: isoDateSchema,
});
export const createContactGroupSchema = z.object({ name: z.string().min(1).max(120) });
export const groupMembershipSchema = z.object({
    _id: objectIdSchema,
    groupId: objectIdSchema,
    contactId: objectIdSchema,
    createdAt: isoDateSchema,
});
/** The STOP/UNSUBSCRIBE/CANCEL family of inbound keywords that trigger auto opt-out. */
export const OPT_OUT_KEYWORDS = ["STOP", "UNSUBSCRIBE", "CANCEL", "END", "QUIT"];
export function isOptOutKeyword(body) {
    const normalized = body.trim().toUpperCase();
    return OPT_OUT_KEYWORDS.includes(normalized);
}
//# sourceMappingURL=contact.js.map